interface NewNotebookProps {
  id: string;
  name: string;
  groups:
    | {
        id: string;
        name: string;
        slug: string;
        subjects: {
          id: string;
          name: string;
          slug: string;
        }[];
        trackers: {
          id: string;
          name: string;
          slug: string;
          type: TrackerType;
        }[];
      }[]
    | null;
  subjects:
    | {
        id: string;
        name: string;
        slug: string;
      }[]
    | null;
  ungroupedSubjects:
    | {
        id: string;
        name: string;
        slug: string;
        trackers: {
          id: string;
          name: string;
          slug: string;
          type: TrackerType;
        }[];
      }[]
    | null;
  trackers:
    | {
        id: string;
        name: string;
        slug: string;
      }[]
    | null;
  isDemo: boolean;
  ownerMember: {
    id: string;
  };
}

export class Notebook {
  public id: string;
  public name: string;
  public subjects: { id: string; name: string; slug: string }[];
  public ungroupedSubjects: {
    id: string;
    name: string;
    slug: string;
    trackers: { id: string; name: string; slug: string; type: TrackerType }[];
  }[];
  public trackers: { id: string; name: string; slug: string }[];
  public isDemo: boolean;
  public ownerMember: { id: string };
  public groups: {
    id: string;
    name: string;
    slug: string;
    subjects: { id: string; name: string; slug: string }[];
    trackers: { id: string; name: string; slug: string; type: TrackerType }[];
  }[];

  public static emptyNotebook() {
    return new Notebook({
      id: '',
      name: '',
      subjects: [],
      ungroupedSubjects: [],
      trackers: [],
      groups: [],
      isDemo: false,
      ownerMember: {
        id: ''
      }
    });
  }

  public constructor(props: NewNotebookProps) {
    this.id = props.id;
    this.name = props.name;
    this.subjects = props.subjects || [];
    this.ungroupedSubjects = props.ungroupedSubjects || [];
    this.trackers = props.trackers || [];
    this.groups = props.groups || [];
    this.isDemo = props.isDemo;
    this.ownerMember = props.ownerMember;
  }
}
